/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Template_Notes_StrippedInputs */

const en_us2_coaching_template_notes_stripped = /** @type {(inputs: Coaching_Template_Notes_StrippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template saved. The notes were left out: they are about one person, not the template.`)
};

const pt_br2_coaching_template_notes_stripped = /** @type {(inputs: Coaching_Template_Notes_StrippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo salvo. As observações ficaram de fora: são de uma pessoa, não do modelo.`)
};

const pt_pt2_coaching_template_notes_stripped = /** @type {(inputs: Coaching_Template_Notes_StrippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo salvo. As observações ficaram de fora: são de uma pessoa, não do modelo.`)
};

/** @type {(inputs: Coaching_Template_Notes_StrippedInputs) => LocalizedString} */
const es_419_coaching_template_notes_stripped = en_us2_coaching_template_notes_stripped;

/** @type {(inputs: Coaching_Template_Notes_StrippedInputs) => LocalizedString} */
const fr_fr2_coaching_template_notes_stripped = en_us2_coaching_template_notes_stripped;

/** @type {(inputs: Coaching_Template_Notes_StrippedInputs) => LocalizedString} */
const de_de2_coaching_template_notes_stripped = en_us2_coaching_template_notes_stripped;

/** @type {(inputs: Coaching_Template_Notes_StrippedInputs) => LocalizedString} */
const it_it2_coaching_template_notes_stripped = en_us2_coaching_template_notes_stripped;

/**
* | output |
* | --- |
* | "Template saved. The notes were left out: they are about one person, not the template." |
*
* @param {Coaching_Template_Notes_StrippedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_template_notes_stripped = /** @type {((inputs?: Coaching_Template_Notes_StrippedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Template_Notes_StrippedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_template_notes_stripped(inputs)
	if (locale === "es-419") return es_419_coaching_template_notes_stripped(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_template_notes_stripped(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_template_notes_stripped(inputs)
	if (locale === "de-DE") return de_de2_coaching_template_notes_stripped(inputs)
	if (locale === "it-IT") return it_it2_coaching_template_notes_stripped(inputs)
	return en_us2_coaching_template_notes_stripped(inputs)
});
export { coaching_template_notes_stripped as "coaching.template_notes_stripped" }